import * as h2Api from '../h2Api'
import * as actions from '../actions/surveys'

const initialState = {
  modalOpen: false,
  forEdit: null,
  originalTitle: null,
  selectedQuestion: null,
  data: []
}
const sort = inp => {
  console.log(inp)

  if (!Array.isArray(inp)) {
    return inp
  }

  return inp.sort((a, b) => {
    if (a.name.toLowerCase() < b.name.toLowerCase()) {
      return -1
    }

    if (a.name.toLowerCase() > b.name.toLowerCase()) {
      return 1
    }

    return 0
  })
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.ADD_SURVEY_QUESTION:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const rslt = action.restCall.result
        const newQuests = [...state.forEdit.questions.filter(q => q.id !== rslt.id), rslt]

        console.log(newQuests)

        try {
          newQuests.sort((a, b) => {
            return a.orderBy - b.orderBy
          })
        } catch (e) {
          console.log("Couldn't sort", newQuests)
        }
        //console.log(newQuests)

        return {
          ...state,
          selectedQuestion: null,
          forEdit: {
            ...state.forEdit,
            questions: newQuests
          }
        }
      }

      return state
    case actions.SURVEY_RENAME_TITLE_TYPING:
      return {
        ...state,
        forEdit: {
          ...state.forEdit,
          name: action.value
        }
      }

    case actions.SURVEY_SELECTED_FOR_RENAME:
      return {
        ...state,
        originalTitle: action.name
      }

    case actions.CREATE_SURVEY:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          data: sort([...state.data, action.restCall.result])
        }
      }

      return state

    case actions.SURVEY_DELETE_QUESTION:
      if (
        action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED &&
        action.restCall.result.success
      ) {
        return {
          ...state,
          forEdit: {
            ...state.forEdit,
            questions: state.forEdit.questions.filter(
              q => q.id != action.surveyQuestionId
            )
          }
        }
      }

      return state

    case actions.LOAD_SURVEYS:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          data: sort(action.restCall.result),
          modalOpen: action.openModal
        }
      }

      return state

    case actions.DISMISS_SURVEY_MODAL:
      return {
        ...state,
        modalOpen: false
      }

    case actions.SELECT_EDIT_SURVEY:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const q = action.restCall.result.questions

        try {
          q.sort((a, b) => {
            return a.orderBy - b.orderBy
          })
        } catch (e) {
          console.log("Couldn't sort", newQuests)
        }

        return {
          ...state,
          forEdit: {
            ...action.restCall.result,
            questions: q
          }
        }
      }

      return state

    case actions.SURVEY_REORDER_QUESTION:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        console.log('HERE', action.restCall.result)

        return {
          ...state,
          forEdit: action.restCall.result
        }
      }

      return state

    case actions.SURVEY_EDIT_QUESTION:
      return {
        ...state,
        selectedQuestion: action.surveyQuestion
      }

    case actions.SELECT_NEW_SURVEY:
      return {
        ...state,
        forEdit: 'new'
      }

    case actions.UNSELECT_EDIT_SURVEY:
      return {
        ...state,
        forEdit: null
      }

    default:
      return state
  }
}
